import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom'
import { useApis } from '../../api/useApiClient';
import { useNotification } from '../../context/NotificationContext';

import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Stack from '@mui/material/Stack';

import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

import Form from '../Common/Form';
import LoadingDetailsView from '../Common/Skeletons/LoadingDetailsView';
import { Menu } from '@mui/material';

const LocationForm = ({ editMode = false }) => {

    const { tenantApi } = useApis();
    const navigate = useNavigate();
    const { showNotification } = useNotification();

    const [formData, setFormData] = useState({
        isActive: true  // Set default value to true
    });
    const [loading, setLoading] = useState(false);

    // Load customer data if in edit mode
    const { id } = useParams(); // Get the item ID from the URL parameters if provided (in edit mode)
    const loadformData = async () => {
        setLoading(true);
        try {
            const res = await tenantApi(`/tenants/locations/${id}`);
            const location = res.data;
            // Explicitly set form data with modified fields, to prevent validation errors from API
            setFormData({
                name: location?.name,
                type: location?.type,
                phoneNumber: location?.phoneNumber,
                address: location?.address,
                additionalInfo: location?.additionalInfo,
                isActive: location?.isActive,
            });
            console.debug("location data loaded successfully:", location);
        } catch (error) {
            console.error("Error loading location data", error);
            showNotification(error.message || "Failed to load location details", 'error');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (editMode) {
            loadformData();
        }
    }, [editMode]);

    // --- end of loading customer data for editing



    // --- Handle input changes
    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };


    // Debug
    useEffect(() => {
        console.debug("Form data changed:", formData);
    }, [formData]);

    // Show skeliton while loading initial data (if in edit mode)
    if (loading)
        return <LoadingDetailsView />


    return (
        <Box sx={{ padding: { xs: 2, sm: 3 }, maxWidth: '800px' }}>
            <Form
                resourceName='Location'
                apiPath='/tenants/locations'
                formData={formData}
                requiredFields={
                    [
                        { name: 'name', label: 'Name' },
                        { name: 'type', label: 'Type' },
                    ]
                }
                editMode={editMode}
                onSubmit={() => {
                    navigate(-1);
                }}
                onCancel={() => {
                    navigate(-1);
                }}
            >
                <Stack spacing={3}>
                    {/* Name Group */}
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                        <TextField
                            label="Name"
                            name="name"
                            value={formData.name || ''}
                            onChange={handleChange}
                            required
                            fullWidth
                        />
                    </Stack>

                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                        <FormControl fullWidth>
                            <InputLabel id="location-type-input-label">Type *</InputLabel>
                            <Select
                                labelId="location-type-input-label"
                                id="location-type-select"
                                name="type"
                                value={formData.type || ''}
                                label="Location type"
                                onChange={handleChange}
                                required
                            >
                                <MenuItem value="office">Office</MenuItem>
                                <MenuItem value="retail">Retail Store</MenuItem>
                                <MenuItem value="virtual">Virtual</MenuItem>
                                <MenuItem value="warehouse">Warehouse</MenuItem>
                                <MenuItem value="workshop">Workshop</MenuItem>
                                <MenuItem value="other">Other</MenuItem>
                            </Select>
                        </FormControl>

                        <TextField
                            label="Phone number"
                            name="phoneNumber"
                            value={formData.phoneNumber || ''}
                            onChange={handleChange}
                            fullWidth
                        />
                    </Stack>

                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                        <TextField
                            label="Address"
                            name="address"
                            value={formData.address || ''}
                            onChange={handleChange}
                            multiline
                            rows={4}
                            fullWidth
                        />
                    </Stack>

                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                        <TextField
                            label="Additional Information"
                            name="additionalInfo"
                            value={formData.additionalInfo || ''}
                            onChange={handleChange}
                            multiline
                            rows={4}
                            inputProps={{ maxLength: 500 }}
                            fullWidth
                        />
                    </Stack>

                    {/* <Stack spacing={2}>
                        <FormGroup>
                            <FormControlLabel disabled control={
                                <Checkbox
                                    name='isActive'
                                    checked={formData.isActive}
                                    onChange={(e) => {
                                        setFormData({ ...formData, isActive: e.target.checked });
                                    }}
                                />
                            } label="Active" />
                        </FormGroup>
                    </Stack> */}
                </Stack>
            </Form>
        </Box>
    );
};

export default LocationForm;